import { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { sendEmail } from 'utils/email';
import { site } from 'config/site';

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await sendEmail(formData);
      setSuccess(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: '',
      });
    } catch (err) {
      setError('Error al enviar el mensaje. Intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  }

  if (success) {
    return (
      <Alert severity="success" sx={{ mb: 2, borderRadius: '12px', background: 'rgba(16,185,129,0.1)', color: '#34D399', border: '1px solid rgba(16,185,129,0.2)' }}>
        <Typography variant="h6" sx={{ mb: 1, color: '#10B981' }}>
          ¡Mensaje enviado!
        </Typography>
        <Typography>
          Gracias por contactarnos. Te responderemos pronto.
        </Typography>
        <Button
          onClick={() => setSuccess(false)}
          sx={{ mt: 2, borderColor: '#10B981', color: '#10B981', '&:hover': { borderColor: '#059669', background: 'rgba(16,185,129,0.1)' } }}
          variant="outlined"
          size="small"
        >
          Enviar otro mensaje
        </Button>
      </Alert>
    );
  }

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ width: '100%' }}>
      <Typography variant="h5" sx={{ mb: 4, fontWeight: 700, color: '#F8FAFC' }}>
        Toma el control de tu TI
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 3, borderRadius: '12px', background: 'rgba(239,68,68,0.1)', color: '#F87171', border: '1px solid rgba(239,68,68,0.2)' }}>
          {error}
        </Alert>
      )}

      <TextField
        fullWidth
        label="Nombre completo"
        name="name"
        value={formData.name}
        onChange={handleChange}
        required
        sx={{ mb: 3 }}
      />

      <TextField
        fullWidth
        label="Email"
        name="email"
        type="email"
        value={formData.email}
        onChange={handleChange}
        required
        sx={{ mb: 3 }}
      />

      <TextField
        fullWidth
        label="Teléfono"
        name="phone"
        value={formData.phone}
        onChange={handleChange}
        sx={{ mb: 3 }}
      />

      <FormControl fullWidth sx={{ mb: 3 }}>
        <InputLabel>Servicio de interés</InputLabel>
        <Select
          name="service"
          value={formData.service}
          onChange={handleChange}
          label="Servicio de interés"
          required
        >
          {site.services.map((service) => (
            <MenuItem key={service.slug} value={service.title} sx={{ color: '#F8FAFC' }}>
              {service.title} ({service.coverage})
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        fullWidth
        label="Mensaje"
        name="message"
        multiline
        rows={4}
        value={formData.message}
        onChange={handleChange}
        placeholder="Describe tu necesidad o proyecto..."
        sx={{ mb: 4 }}
      />
      
      <Button
        type="submit"
        variant="contained"
        color="primary"
        disabled={loading}
        fullWidth
        size="large"
        sx={{ py: 1.5, fontSize: '1.1rem' }}
      >
        {loading ? 'Enviando...' : 'Enviar mensaje'}
      </Button>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 3, textAlign: 'center' }}>
        También puedes contactarnos directamente por WhatsApp:{' '}
        <a 
          href={site.whatsapp.link}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#60A5FA', fontWeight: 600, textDecoration: 'none' }}
        >
          {site.whatsapp.number}
        </a>
      </Typography>
    </Box>
  );
}
